import React from "react";
import UserTransactionHistory from "../user/UserTransactionHistory";

const TransactionHistory = () => (
  <UserTransactionHistory
    title="Transactions"
    lead="Tous les paiements effectués sur Platform98."
    staff
  />
);

export default TransactionHistory;
